import React from 'react';
import Services1 from './1';
import Services2 from './2';
import Services3 from './3';
// import Services4 from './4';
import Services5 from './5';

function Services() {
  return (
    <>
      <Services1 />
      <Services2 />
      {/* <Services4 /> */}
      <Services5 />
      <Services3 />
    </>
  );
}

export default Services;
